import React from "react";
import styled from "styled-components";
import { reduxForm, Form, Field } from "redux-form";

import { GoogleSocialAuthButton } from "../../containers";
import { FormInput } from "../../../common";
import { AppStateDisplay } from "../../../common";
import strings from "../../../../res/strings";

const RegisterFormContentContainer = styled(Form)`
  padding: 15%;
  padding-top: 25vh;
`;
const RegisterFormContent = styled.div`
  padding: 24px;
`;
const RegisterFormButtons = styled.div`
  padding: 0px 24px 24px 24px;
`;
const SignInButton = styled.button`
  width: 100%;
  background: #039095;
  border-radius: 250.251px;
  font-size: 1.5em;
  font-family: Secular One;
  color: #ffffff;
  align-items: center;
  text-align: center;
  letter-spacing: 0.05em;
  padding: 16px;
  :focus {
    outline: none;
    box-shadow: 0px 0px 2px #0066ff;
  }
`;
const SignInRedirect = styled.div`
  margin-top: 16px;
  width: 100%;
  text-align: center;
`;
const RegisterTitle = styled.div`
  font-family: Secular One;
  font-style: normal;
  font-weight: normal;
  font-size: 2em;
  line-height: 73px;
  letter-spacing: 0.1em;

  color: #929292;
  text-align: center;
`;
const RouterLink = styled.a`
  color: #929292;
  font-family: Secular One;
  cursor: pointer;

  :hover {
    color: #7a7a7a;
  }
`;
const FieldsContainer = styled.div`
  margin-top: 16px;
`;

const RegisterForm = (props) => {
  return (
    <RegisterFormContentContainer onSubmit={props.handleSubmit}>
      <RegisterFormContent>
        <RegisterTitle>CREATE AN ACCOUNT</RegisterTitle>
        <AppStateDisplay />
        <FieldsContainer>
          <Field
            name="email"
            component={FormInput}
            label={strings.lib_authentication_label_email}
            type="email"
            required
            maxlength={255}
            placeholder={"EMAIL"}
          />
          <Field
            name="password"
            component={FormInput}
            label={strings.lib_authentication_label_password}
            type="password"
            required
            minlength={8}
            maxlength={128}
            placeholder={"PASSWORD"}
          />
          <Field
            name="confirmPassword"
            component={FormInput}
            label={strings.lib_authentication_label_password_confirm}
            type="password"
            required
            minlength={8}
            maxlength={128}
            placeholder={"CONFIRM PASSWORD"}
          />
        </FieldsContainer>
      </RegisterFormContent>

      <RegisterFormButtons>
        <SignInButton type="submit" color="primary">
          REGISTER
        </SignInButton>
        <GoogleSocialAuthButton />
        <SignInRedirect>
          <RouterLink onClick={() => props.setRightPanel("LOGIN")}>
            {strings.lib_authentication_redirect_existing_account}
          </RouterLink>
        </SignInRedirect>
      </RegisterFormButtons>
    </RegisterFormContentContainer>
  );
};

const ReduxRegisterForm = reduxForm({
  form: "lib_authentication_register",
})(RegisterForm);

export default ReduxRegisterForm;
